var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"we-loading-overflow"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t("loading")))]),_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }